module.exports = __webpack_public_path__ + "static/media/shellhacks.301cf75e.svg";